import xhr from "xhr";
import validator from "./type_validator";
import api from "./api";
import setOrigin from "./setOrigin";
import getUrlParameter from "./getUrlParams";

const formSubmission = () => {
    let currentPage = document.querySelector(".page__form"),
      form = currentPage.querySelector(".form"),
      dealer = document.querySelector("#dealer"),
      radios = document.getElementsByName("civility"),
      checkedRadioValue = 0,
      campaignSlug = currentPage.getAttribute("data-campaign"),
      campaignFormSlug = currentPage.getAttribute("data-form"),
      formType = currentPage.getAttribute("data-form-type"),
      email = document.querySelector("#consentEmail"),
      courrier = document.querySelector("#consentCourrier"),
      message = document.querySelector("#consentPhoneService"),
      vehicule = document.querySelector("#consentCarConnectedService"),
      generalConsent = document.querySelector("#consentGeneral"),
      marketingConsent = document.querySelector("#consentMarketing"),
      vehicule_name = currentPage.getAttribute("data-vehicule"),
      vehicule_id = currentPage.getAttribute("data-id"),
      submitBtn = form.querySelector('button[type="submit"]');



	var serializeArray = function (form) {
		var serialized = [];
		for (var i = 0; i < form.elements.length; i++) {
			var field = form.elements[i];
			if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') {
				continue
			}
			if (field.type === 'select-multiple') {
				for (var n = 0; n < field.options.length; n++) {
					if (!field.options[n].selected) continue;
					serialized[field.name] = field.options[n].value

				}
			}
			else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
				serialized[field.name] = field.value
			}
		}
		return serialized;
	};

    const notkg = document.body.classList.contains('notkg');

    for (let i = 0, length = radios.length; i < length; i++) {
      if (radios[i].checked) {
        checkedRadioValue = radios[i].value;
        break;
      }
    }

    let consentLabel = "";

    if (form.classList.contains("form__centered")) {
      let civilityRadio = document.querySelector(".civility-label");
      if (civilityRadio) {
        checkedRadioValue = civilityRadio.getAttribute("data-value");
      }
    }
    if(email) {
        if (email.checked) {
          consentLabel += "mail,";
        }
    }
    if(courrier) {
        if (courrier.checked) {
          consentLabel += "courrier,";
        }
    }
    if(message) {
        if (message.checked) {
          consentLabel += "message,";
        }
    }
    if(vehicule) {
        if (vehicule.checked) {
          consentLabel += "vehicule,";
        }
    }
    if(marketingConsent) {
        if (marketingConsent.checked) {
          consentLabel += "marketing,";
        }
    }

    if(generalConsent) {
        if (generalConsent.checked) {
          consentLabel += "general,";
        }
    }

    let dataPayload = {
      event: "Formulaire validé",
      category: `Formulaire validé, ${formType}`,
      action: vehicule_name,
      label: consentLabel.replace(/,$/, ""),
      value: null
    };


    // let cityVal =
      let dealer_id = "";

    if(formType === "RFO-O" || formType === "RFO-SL" || formType === "IUCP")
    {
        dealer_id = currentPage.getAttribute("data-dealer-id");
    } else
    {
        dealer_id = dealer ? dealer.getAttribute("data-dealer") : "";
    }
    let formPayload = {};
    formPayload = {
      origin: `${setOrigin()}`,
      preview: window.location.href.indexOf("preview") >= 0 ? "1" : "0",
      lead: {
        firstname: document.getElementById("firstname") ? document.getElementById("firstname").value : '',
        lastname: document.getElementById("lastname") ? document.getElementById("lastname").value : '',
        civility: checkedRadioValue,
        email: document.getElementById("email") ? document.getElementById("email").value : '',
        mobile: document.querySelector("#phone") ? document.querySelector("#phone").value : '',
        address: document.querySelector("#address") ? document.querySelector("#address").getAttribute("street") : '',
        city: document.querySelector("#city") ? document.querySelector("#city").value : '',
        zipcode: document.querySelector("#zipcode") ? document.querySelector("#zipcode").value : ''
      },
      consents: {
        purpose: currentPage.getAttribute("data-purpose"),
        policy_name: currentPage.getAttribute("data-policy-name"),
        policy_version: currentPage.getAttribute("data-policy-version"),
        consent_email: email && email.checked ? "1" : "0", // 1 if checkbox is checked / else 0
        consent_courrier: courrier && courrier.checked ? "1" : "0",
        consent_message: message && message.checked ? "1" : "0",
        consent_vehicule: vehicule && vehicule.checked ? "1" : "0",
        consentMarketing: marketingConsent && marketingConsent.checked ? "1" : "0",
        consent: generalConsent && generalConsent.checked ? "1" : "0"
      },
      dealer: {
        id: dealer_id
      },
      campaign_id: currentPage.getAttribute("data-campaign-id"),
      vo_offer_code: currentPage.getAttribute("data-vo-offer-code"),
      vo_product_code: currentPage.getAttribute("data-vo-product-code"),
      vo_brand: currentPage.getAttribute("data-vo-brand"),
      product_code: currentPage.getAttribute("data-product-code"),
      transaction_id: currentPage.getAttribute("data-transaction-id"),
      offer_id: currentPage.getAttribute("data-offer-id"),
      b2b_restriction: currentPage.getAttribute("data-b2b-restriction"),
      configId: document.querySelector("#configId").value
    };

    if(currentPage.getAttribute("data-fv")) {
        formPayload.form_version = currentPage.getAttribute("data-fv");
    }
    if(document.getElementById("raison-sociale")) {
        formPayload.raison_sociale = document.getElementById("raison-sociale").value;
    }
    if(document.getElementById("vehicleModelCode")) {
        formPayload.vehicleModelCode = document.getElementById("vehicleModelCode").value;
    }
    if(document.getElementById("vehicleModelOptions")) {
        formPayload.vehicleModelOptions = document.getElementById("vehicleModelOptions").value;
    }
    if(document.getElementById("taille-parc")) {
        formPayload.taille_parc = document.getElementById("taille-parc").getAttribute("data-value");
    }
    if(document.getElementById("subscriber-type")) {
        formPayload.subscriber_type = document.getElementById("subscriber-type").getAttribute("data-value");
    }
    if(document.getElementById("message")) {
        formPayload.lead.message = document.getElementById("message").value;
    }

    if(document.querySelector('input[name="context"]:checked')) {
        formPayload.context = document.querySelector('input[name="context"]:checked').value;
    }

    if(document.querySelector('input[name="licence"]:checked')) {
        formPayload.lead.licence = document.querySelector('input[name="licence"]:checked').value
    }

    if(document.querySelector('input[name="recall"]:checked')) {
        formPayload.lead.recall = document.querySelector('input[name="recall"]:checked').value
    }

	// send full form to payload
	const campaignForm = document.querySelector('main > form')

	// construct array of form fields for rawFormData
	formPayload.rawFormData = {};
	const formData = serializeArray(campaignForm)
	for (let key in formData) {
		if (formData.hasOwnProperty(key)) {
			formPayload.rawFormData[key] = formData[key]
		}
	}


    if(formType === "RFC")
    {
        if (document.querySelector("#subscriber-type")) {
            formPayload.subscriber_type = document.querySelector("#subscriber-type").getAttribute("data-value");
        }
        if (document.querySelector("#echeance-park")) {
            formPayload.echeance_parc = document.querySelector("#echeance-park").getAttribute("data-value");
        }
        if (document.querySelector(".form__input--message")) {
            formPayload.comment = document.querySelector(".form__input--message").value;
        }

        if (document.querySelectorAll(".form__input--comments")) {
            let commentsFields = document.querySelectorAll(".form__input--comments")
            let commentsValues = []
            commentsFields.forEach(el => {
                let name, value
                if(el.getAttribute('name')){
                    name = el.getAttribute('name')
                }
                else{
                    name = el.getAttribute('data-name')
                }
                if(el.getAttribute('data-value')){
                    value = el.getAttribute('data-value')
                }
                else{
                    value = el.value
                }
                commentsValues.push(name + ':' + value)
            })
            if(formPayload.comment){
                commentsValues.push(formPayload.comment)
            }
            formPayload.comment = commentsValues.join(', ')
        }
        if (document.querySelector(".form__input--vehicle")) {
            let el = document.querySelector(".form__input--vehicle")
            if(el.getAttribute('data-id')){
                formPayload.vehicle = el.getAttribute('data-id')
            }
            if(el.getAttribute('data-brand')!==''){
                formPayload.brand = el.getAttribute('data-brand')
            }
        }
    } else
    {
      if(formType === "RFC-FRANCHISE")
      {
        formPayload.raison_sociale = document.querySelector("#raison-sociale").value;
        formPayload.subscriber_type = document.querySelector("#subscriber-type").getAttribute("data-value");
        formPayload.comment = document.querySelector(".form__input--message").value;
      } else
      {
        if(formType === "RFO-SL" || formType === "IUCP")
        {
          formPayload.vin = currentPage.getAttribute("data-sl-vin");
        } else
        {
          if(formType === "RFO")
          {
            formPayload.config_id = currentPage.getAttribute("data-rfo-config-id");
            formPayload.model_code = currentPage.getAttribute("data-rfo-model-code");
            formPayload.hybrid = currentPage.getAttribute("data-rfo-hybrid");
            formPayload.options = currentPage.getAttribute("data-options");
          }
        }
      }
    }


    let params = new URLSearchParams(window.location.search);
    params.delete('VIN');
    params.delete('vin');
    let requestParams = params.toString();
    let link = "";

  if(typeof confirmUrl !== 'undefined') {
    link = `${api().bmw}` +  confirmUrl.replace(api().appPrefix, '');
    if (requestParams) {
      link = link + '?' + requestParams;
    }
  } else {
    if (requestParams) {
      link = `${
        api().bmw
      }/${campaignSlug}/${campaignFormSlug}/confirm?${requestParams}`;
    } else {
      link = `${api().bmw}/${campaignSlug}/${campaignFormSlug}/confirm`;
    }
  }
    xhr(
      {
        method: "POST",
        body: JSON.stringify(formPayload),
        uri: `${
        api().bmw
        }/${campaignSlug}/${campaignFormSlug}/${vehicule_id}/validate`,
        headers: {
          "Content-Type": "application/json"
        },
        "Access-Control-Allow-Origin": `${
        api().bmw
        }/${campaignSlug}/${campaignFormSlug}/${vehicule_id}/validate`
      },
    (err, resp, body) => {
      let data = JSON.parse(body);
      if (data.status == "ok") {
        // dataLayer.push(dataPayload);
        //Measure the number of request sent with success for all forms
        if(!notkg && typeof _satellite != 'undefined') {
            _satellite.track('FormConfirmed');
        }
        if (requestParams && link.indexOf('?') > 0) {
            window.location.href = `${link}`  + '&hash=' + data.hash;
        } else {
            window.location.href = `${link}`  + '?hash=' + data.hash;
        }
        const form = document.querySelector(".page__form");
      } else {
        const res = JSON.parse(resp.body);
        for (const key in res) {
          if (res.hasOwnProperty(key)) {
            const element = res[key];
            if (element === false) {
              let falseInput = document.getElementById(`${key}`);
              falseInput.parentElement.classList.add("error");
              validator().showErrorMsg(falseInput);
              console.log(falseInput.name + ' field has not been filled correctly');
                if (!notkg && typeof _satellite !== 'undefined') {
                    _satellite.track('error', {
                            errorType: 'user',
                            errorCause: 'invalid input',
                            errorMessage: falseInput.name + ' field has not been filled correctly',
                            errorCode: null,
                            errorOrigin: 'backend_form_validator'
                        }
                    );
                }
            }
          }
        }
        submitBtn.classList.remove("disabled");
        submitBtn.disabled = false;
      }
    }
  );



};

export default formSubmission;
